export * from './wall-type-7.component'